import {Injectable} from '@angular/core';
import * as fb from 'firebase';

@Injectable()
export class FirebaseStorageService {

  constructor() {
  }


  /**
   * Upload File To FireStorage
   * @param {string} folder
   * @param {string} org_id
   * @param {File} file
   * @returns {firebase.storage.UploadTask}
   */
  uploadFile(path: string, org_id: string, file: File) {
    // Create a root reference
    const storageRef = fb.storage().ref();
    // Create uploadPath
    const fileRef = storageRef.child(path);

    // Set File MetaData
    const metadata = {
      contentType: file.type,
      org_id: org_id
    };

    const uploadTask = fileRef.put(file, metadata);
    return uploadTask;
  }


  /**
   * Removes a saved file from FireStorage
   * @param {string} path
   * @returns {Promise<any>}
   */
  removeFile(path: string) {
    // Create a root reference
    const storageRef = fb.storage().ref();
    // Create uploadPath
    const fileRef = storageRef.child(path);
    const removeTask = fileRef.delete();
    return removeTask;
  }

}



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/services/firebase/firebase-storage.service.ts